/* import __COLOCATED_TEMPLATE__ from './lowpass-sallenkey-gain.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();